import { render } from "./ProdOrderItemList.vue?vue&type=template&id=5d82fffc"
import script from "./ProdOrderItemList.vue?vue&type=script&lang=js"
export * from "./ProdOrderItemList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__